import { useState } from 'react'
import { useNotify } from 'react-admin'
import { IconButton } from '@mui/material'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

const CustomCopyButton = ({
  sx = null,
  iconFontSize = 'small',
  iconColor = '#111',
  content,
  notification = 'Information copiée dans le presse-papier',
}) => {
  const notify = useNotify()
  const [isCopied, setIsCopied] = useState(false)
  
  const handleCopy = () => 
    navigator.clipboard.writeText(content)
      .then(() => {
        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 3000)
        notify(notification, { type: 'success' })
      })
      .catch(err => console.error('Failed to copy: ', err))

  return content ? (
    <IconButton
      size="small"
      onClick={e => {
        handleCopy()
        e.stopPropagation()
      }}
      sx={sx}
    >
      { isCopied
        ? <CheckCircleIcon fontSize={iconFontSize} color="success" />
        : <ContentCopyIcon fontSize={iconFontSize} color={iconColor} /> }
    </IconButton>
  ) : null
}

export default CustomCopyButton